import useCountDown from "@pathwright/ui/src/components/hooks/useCountDown"
import Dateicon from "@pathwright/ui/src/components/infoicons/Dateicon"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import Text from "@pathwright/ui/src/components/ui/Text"
import {
  DANGEROUS_RED,
  WARNING_ORANGE
} from "@pathwright/ui/src/components/utils/colors"
import moment from "moment"
import PropTypes from "prop-types"

const LearnPathScheduleLabel = ({ pathItem, inverted }) => {
  const { tc } = useTranslate()

  const { starts, due } = pathItem

  const dueForceUpdate = useCountDown(due)
  const startsForceUpdate = useCountDown(starts)

  if (pathItem.progress === 1) {
    return null
  }

  if (starts && moment().isBefore(starts)) {
    if (pathItem.passive_starts) {
      return (
        <Text.Meta inverted={inverted}>
          {tc("Starts {{date}}", { date: moment(starts).format("MMM D") })}
        </Text.Meta>
      )
    }

    return (
      <Text.Meta inverted={inverted}>
        <Pathicon icon="unlock" />{" "}
        {tc("Unlocks {{date}}", { date: moment(starts).format("MMM D") })}
      </Text.Meta>
    )
  }

  if (due) {
    if (pathItem.passive_due) {
      if (moment(due).isAfter()) {
        return (
          <Tooltip title={tc("Ends {{date}}", { date: moment(due).fromNow() })}>
            <Dateicon date={due} />
          </Tooltip>
        )
      }
    } else if (pathItem.permissions.can_complete) {
      return (
        <Tooltip title={tc("Due {{date}}", { date: moment(due).fromNow() })}>
          <Dateicon
            date={due}
            color={moment(due).isAfter() ? WARNING_ORANGE : DANGEROUS_RED}
          />
        </Tooltip>
      )
    }
  }

  return null
}

LearnPathScheduleLabel.displayName = "LearnPathScheduleLabel"

LearnPathScheduleLabel.propTypes = {
  pathItem: PropTypes.object.isRequired
}

export default LearnPathScheduleLabel
